"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8-.001 8 8 0 0 0 8 16Zm-.82-9H6v1.36h1.18v3.51H8.6v-3.5h1.17L9.94 7H8.6v-.9a.7.7 0 0 1 .14-.46.69.69 0 0 1 .48-.17H10V4.26c-1-.09-1.76-.15-2.31.4a1.74 1.74 0 0 0-.49 1.25L7.18 7Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 24A12 12 0 1 0 12 .001 12 12 0 0 0 12 24Zm-1.23-13.5H9v2.04h1.77v5.265h2.13v-5.25h1.755l.255-2.055H12.9V9.15a1.05 1.05 0 0 1 .21-.69c.199-.174.456-.265.72-.255H15V6.39c-1.5-.135-2.64-.225-3.465.6a2.608 2.608 0 0 0-.735 1.875l-.03 1.635Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Zm-1.64-18H12v2.72h2.36v7.02h2.84v-7h2.34l.34-2.74H17.2v-1.8a1.4 1.4 0 0 1 .28-.92 1.38 1.38 0 0 1 .96-.34H20V8.52c-2-.18-3.52-.3-4.62.8a3.479 3.479 0 0 0-.98 2.5L14.36 14Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24 48a24 24 0 1 0 0-48 24 24 0 0 0 0 48Zm-2.46-27H18v4.08h3.54v10.53h4.26v-10.5h3.51l.51-4.11H25.8v-2.7a2.1 2.1 0 0 1 .42-1.38 2.07 2.07 0 0 1 1.44-.51H30v-3.63c-3-.27-5.28-.45-6.93 1.2a5.222 5.222 0 0 0-1.47 3.75L21.54 21Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32 64a32 32 0 1 0 0-64 32 32 0 0 0 0 64Zm-3.28-36H24v5.44h4.72v14.04h5.68v-14h4.68l.68-5.48H34.4v-3.6a2.8 2.8 0 0 1 .56-1.84 2.76 2.76 0 0 1 1.92-.68H40v-4.84c-4-.36-7.04-.6-9.24 1.6a6.96 6.96 0 0 0-1.96 5L28.72 28Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconFacebook = function IconFacebook(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Facebook' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Facebook"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconFacebook.sizes = [16, 24, 32, 48, 64];
IconFacebook.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconFacebook;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/social/Facebook.js
// module id = 2293
// module chunks = 0